module.exports = __webpack_public_path__ + "static/img/news1.6e7b3b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/news1.jpg
// module id = YMgR
// module chunks = 1